<div class="command-config-page">
  <div class="page-header page-header--no-search">
    <div class="page-header__title">
      <h2>{{ 'Command configuration' | translate }}</h2>
      <p>{{ 'Host IOptions used by commands. Overlay in Common DB wins over appsettings.' | translate }}</p>
    </div>
  </div>

  @if (errorMessage()) {
    <div class="error-message">{{ errorMessage() | translate }}</div>
  }

  @if (loading()) {
    <app-loading [loading]="true"></app-loading>
  } @else {
    <div class="orch-table-panel">
      <app-orchestration-table-heading heading="Command configuration" [query]="searchQuery()" (queryChange)="onCatalogSearch($event)">
        <div tableActions class="table-actions">
          <app-secondary-button title="Refresh" icon="refresh" (action)="load()"></app-secondary-button>
        </div>
      </app-orchestration-table-heading>
      <app-data-table
        [columns]="columns()"
        [data]="visibleSections()"
        [config]="tableConfig()"
        (onRowClick)="selectSection($event)"
      ></app-data-table>
      <ng-template #translatedCell let-row let-fieldName="fieldName">
        {{ (row[fieldName] || '—') | translate }}
      </ng-template>
      <ng-template #processesTemplate let-row>
        <app-command-config-links [sectionName]="row.sectionName"></app-command-config-links>
      </ng-template>
      <ng-template #editActionTemplate let-row>
        <div class="row-edit" (click)="$event.stopPropagation()">
          <app-secondary-button
            title="Edit"
            icon="pi pi-pencil"
            size="small"
            (action)="selectSection(row)"
          ></app-secondary-button>
        </div>
      </ng-template>
    </div>
  }

  <p-dialog
    [visible]="editorOpen()"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
    [header]="dialogTitle()"
    [style]="{ width: 'min(960px, 96vw)' }"
    (visibleChange)="onEditorVisible($event)"
  >
    @if (editorSection(); as name) {
      <app-orchestration-command-config-detail
        [sectionName]="name"
        (saved)="load()"
      ></app-orchestration-command-config-detail>
    }
  </p-dialog>
</div>
